import { useNavigate } from '@tanstack/react-router'
import type { QuoteFile } from '../files/api'

/** Opens the import workspace on a file from the quote's Files (the Customer stage's "Import equipment"). */
export function useQuoteFileImport(quoteId: string) {
  const navigate = useNavigate()
  return (file: Pick<QuoteFile, 'id' | 'original_file_name'>) =>
    void navigate({
      to: '/quotes/$quoteId/workflow/$stage',
      params: { quoteId, stage: 'equipment' },
      search: { import: 1, file: file.id, name: file.original_file_name },
    })
}
